import { IconButton, Tooltip } from "@mui/material";
import { useTranslation } from "react-i18next";
import NavigateBeforeIcon from "@mui/icons-material/NavigateBefore";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import FirstPageIcon from "@mui/icons-material/FirstPage";
import LastPageIcon from "@mui/icons-material/LastPage";

const PreviousYearButton = ({onClick}) => {
  const {t} = useTranslation();

  const handleClick = (e) => {
    if (typeof onClick === 'function') {
      onClick(e);
    }
  }

  return (
    <Tooltip title={t("Vorjahr")} arrow>
      <IconButton onClick={handleClick}>
        <FirstPageIcon />
      </IconButton>
    </Tooltip>
  );
};

const NextYearButton = ({onClick}) => {
  const {t} = useTranslation();

  const handleClick = (e) => {
    if (typeof onClick === 'function') {
      onClick(e);
    }
  }

  return (
    <Tooltip title={t("Nächstes Jahr")} arrow>
      <IconButton onClick={handleClick}>
        <LastPageIcon />
      </IconButton>
    </Tooltip>
  );
};

const PreviousMonthButton = ({onClick}) => {
  const {t} = useTranslation();

  const handleClick = (e) => {
    if (typeof onClick === 'function') {
      onClick(e);
    }
  }

  return (
    <Tooltip title={t("Vormonat")} arrow>
      <IconButton onClick={handleClick}>
        <NavigateBeforeIcon />
      </IconButton>
    </Tooltip>
  );
};

const NextMonthButton = ({onClick}) => {
  const {t} = useTranslation();

  const handleClick = (e) => {
    if (typeof onClick === 'function') {
      onClick(e);
    }
  }

  return (
    <Tooltip title={t("Nächster Monat")} arrow>
      <IconButton onClick={handleClick}>
        <NavigateNextIcon />
      </IconButton>
    </Tooltip>
  );
};

export {NextMonthButton, PreviousMonthButton, NextYearButton, PreviousYearButton}